import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ProductImageComponent } from "@components/product-image/product-image.component";
import { ProductImage } from "@domain/product/product-image";
import { MonitoringSearchResult } from "@project/monitoring/monitoring-search-result";

@Component({
  selector: "app-monitoring-search-item",
  templateUrl: "./monitoring-search-item.component.html",
  styleUrl: "./monitoring-search-item.component.scss",
  imports: [UiKitModule, ProductImageComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringSearchItemComponent {
  @Input({ required: true }) result!: MonitoringSearchResult;
  @Input() showAddToBomMenuItem = true;
  @Input() canAddToFloorplan = true;
  @Input() isShownOnProductList = false;

  @Output() addToFloorplan = new EventEmitter<MonitoringSearchResult>();
  @Output() showGroupDetails = new EventEmitter<MonitoringSearchResult>();
  @Output() addToBom = new EventEmitter<MonitoringSearchResult>();

  protected get displayName(): string {
    return this.result.kind === "group" ? this.result.option.groupName : this.result.device.name;
  }

  protected get displayId(): string {
    if (this.result.kind === "group") {
      return $localize`:@@monitoring.productSearch.groupDeviceCount:${this.result.option.devices.length} Geräte`;
    }
    return this.result.device.matNr;
  }

  protected get isGroup(): boolean {
    return this.result.kind === "group";
  }

  protected get imageUrl(): string | undefined {
    if (this.result.kind === "group" && this.result.option.groupImageCantoID) {
      return ProductImage.getCantoSourceUrl(this.result.option.groupImageCantoID);
    }
    if (this.result.kind === "device" && this.result.device.productImageCantoID) {
      return ProductImage.getCantoSourceUrl(this.result.device.productImageCantoID);
    }
    return undefined;
  }

  protected onCardClick(): void {
    if (!this.canAddToFloorplan || this.isShownOnProductList) {
      this.onAddToBomClick();
      return;
    }
    this.addToFloorplan.emit(this.result);
  }

  protected onShowGroupDetailsClick(): void {
    this.showGroupDetails.emit(this.result);
  }

  protected onAddToBomClick(): void {
    this.addToBom.emit(this.result);
  }
}
